<template>
  <div class="ui-time-expired">
    <div class="ui-time-expired__content">
      <div class="content__body content__body--intro">
        <p class="content__text" v-html="$translate('timeExpired').content"/>

        <a class="content__image" :href="link" target="_blank" rel="noopener noreferrer">
          <img class="content__app-icon" src="/img/icons/gucciapp.png" alt="Gucci app icon">
        </a>

        <ButtonRounded
          class="content__button"
          :content="$translate('timeExpired').button"
          action="intro"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ButtonRounded from '@/components/ButtonRounded.vue';

export default {
  name: 'TimeExpired',

  components: {
    ButtonRounded,
  },

  computed: {
    link() {
      let link;
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      if (/android/i.test(userAgent)) {
        link = 'https://play.google.com/store/apps/details?id=com.gucci.gucciapp';
      } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        link = 'itms-apps://apps.apple.com/it/app/gucci/id334876990';
      }

      return link;
    },
  },
};
</script>

<style lang="scss" scoped>
.ui-time-expired {
  pointer-events: auto;

  display: flex;
  align-items: center;
  justify-content: center;

  color: $color-yellow;

  .content__app-icon {
    width: 60px;
  }

  &__content {
    position: absolute;
    width: 100%;
    bottom: 20vh;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-flow: column nowrap;

    .content__body {
      height: 60vh;

      display: flex;
      align-items: center;
      justify-content: space-around;
      flex-flow: column nowrap;

      color: $color-yellow;
      text-align: center;
      font-weight: 800;
      @extend %font-medium;
    }
  }
}
</style>
